import React, { useEffect, useState } from "react";
import logo from "../assetsWeb/images/header-logo.png";
import footerlogo from "../assetsWeb/images/footer-logo.png";
import googlee from "../assetsWeb/images/Google_Play_Store_badge_EN.png";
import applee from "../assetsWeb/images/Download_on_the_App_Store_RGB_blk.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegCircleUser } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../actions/userActions";
import { createOrder } from "../actions/orderActions";
import { userCustLogin, userLogout } from "../actions/authActions";

const HomeSignUpPage = () => {
  const auth = useSelector((state) => state.auth);
  const items = useSelector((state) => state.items);
  const { itemsDetails } = useSelector((state) => state.items);
  const dispatch = useDispatch();
  const locationUrl = useLocation();
  const queryParams = new URLSearchParams(locationUrl.search);
  const returnUrl = queryParams.get("returnUrl");
  console.log(auth, "auth");
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    role: "user",
    gender: "male",
    password: "abcd1234",
  });
  console.log(values, "values");

  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };

  const userData = {
    // userId: values.userId,
    firstName: values.firstName,
    lastName: values.lastName,
    phone: values.phone,
    email: values.email,
    role: "user",
    gender: "male",
    password: "abcd1234",
  };

  // Handle increasing quantity

  const handlePhone = (fieldName) => (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (numericValue.length > 0) {
      formattedValue = `(${numericValue.slice(0, 3)}`;
    }
    if (numericValue.length > 3) {
      formattedValue += `)${numericValue.slice(3, 6)}`;
    }
    if (numericValue.length > 6) {
      formattedValue += `-${numericValue.slice(6, 10)}`;
    }
    setValues({
      ...values,
      [fieldName]: formattedValue,
    });
  };
  let navigate = useNavigate();
  const navigateUser = () => {
    returnUrl ? navigate(returnUrl) : navigate("/");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("first");
    for (let key of Object.keys(userData)) {
      if (userData[key] === "") {
        delete userData[key];
      }
    }
    dispatch(createUser(userData, navigateUser));
    // dispatch(userCustLogin(userData, navigateUser));
  };
  const navigateHome = () => {
    navigate("/");
  };
  const logout = async (e) => {
    await dispatch(
      userLogout({ refreshToken: auth.tokens.refresh.token, navigateHome })
    );
  };

  return (
    <>
      <div className="bitefooflyheader-section bitefooflyheader-section2">
        <div className="container-fluid mb-3">
          <div className="row">
            <div className="riawiza-header-img">
              <nav className="navbar navbar-expand-lg navbar-light bg-light-subtle ">
                <div className="container">
                  {/* <!-- Logo --> */}
                  <Link className="navbar-brand" to="/">
                    <img
                      src={logo}
                      alt="Logo"
                      id="logsedf"
                      style={{ width: "52%" }}
                    />
                  </Link>
                  {/* <!-- Toggle button for small screens --> */}
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  {/* <!-- Navbar links --> */}
                  <div
                    className="collapse navbar-collapse justify-content-end"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        {/* <a
                          className="nav-link btn btn-light rounded-pill"
                          href=""
                        >
                          <i className=" fa fa-user-circle"></i> Login
                        </a> */}
                        {/* <Link
                          to="/all"
                          role="button"
                          className="button-21"
                          style={{ marginRight: "20px", color: "#000" }}
                        >
                          <span className="icon-user">
                            <i
                              className="fa-solid fa-cart-shopping"
                              title="Show cart"
                            ></i>
                          </span>{" "}
                        </Link> */}

                        {auth?.user?.role === "user" ? (
                          <button
                            // to="/login"
                            className="button-21"
                            role="button"
                            style={{ marginRight: "20px", color: "#000" }}
                            onClick={logout}
                          >
                            <span className="icon-user">
                              <FaRegCircleUser />
                            </span>{" "}
                            &nbsp;Logout
                          </button>
                        ) : (
                          <>
                            {/* <Link
                              to="/sign-up"
                              className="button-21"
                              role="button"
                              style={{ marginRight: "20px", color: "#000" }}
                            >
                              <span className="icon-user">
                                <FaRegCircleUser />
                              </span>{" "}
                              &nbsp;Sign up
                            </Link> */}
                            <Link
                              to="/login"
                              className="button-21"
                              role="button"
                              style={{ marginRight: "20px", color: "#000" }}
                            >
                              <span className="icon-user">
                                <FaRegCircleUser />
                              </span>{" "}
                              &nbsp;Login
                            </Link>
                          </>
                        )}
                        {/* {values?.itemsId?.length > 0 ? (
                          <Link
                            to="/checkout"
                            role="button"
                            className="button-21"
                            style={{ marginRight: "20px", color: "#000" }}
                          >
                            <span className="icon-user">
                              <i
                                className="fa-solid fa-bag-shopping"
                                title="Checkout"
                              ></i>{" "}
                              {values.itemsId.length}{" "}
                            </span>{" "}
                          </Link>
                        ) : (
                          <Link
                            to="/#"
                            role="button"
                            className="button-21"
                            style={{ marginRight: "20px", color: "#000" }}
                          >
                            <span className="icon-user">
                              <i
                                className="fa-solid fa-bag-shopping"
                                title="Checkout"
                              ></i>{" "}
                              {values?.itemsId?.length || 0}{" "}
                            </span>{" "}
                          </Link>
                        )} */}
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* {values?.itemsId?.length > 0 ? ( */}
      <div className="categ-section">
        <br />
        <br />
        <div className="categories-container">
          <div className="checkout-container">
            <h2>Sign Up</h2>
            <form id="checkout-form" onSubmit={handleSubmit}>
              {
                // auth && auth.user === null && (
                <>
                  <div className="form-group">
                    <strong>First Name:</strong>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter firstName"
                      value={values.firstName}
                      required
                      // value={`${values.firstName} ${values.lastName}`}
                      onChange={handleChange("firstName")}
                      // defaultValue={`${auth.user.firstName} ${auth.user.lastName}`}
                    />
                  </div>
                  <div className="form-group">
                    <strong>Last Name:</strong>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter lastName"
                      value={values.lastName}
                      required
                      // value={`${values.firstName} ${values.lastName}`}
                      onChange={handleChange("lastName")}
                      // defaultValue={`${auth.user.firstName} ${auth.user.lastName}`}
                    />
                  </div>
                  <div className="form-group">
                    <strong>Email:</strong>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email"
                      value={values.email}
                      required
                      onChange={handleChange("email")}
                      // defaultValue={auth.user.email}
                    />
                  </div>
                  <div className="form-group">
                    <strong>Phone:</strong>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter phone"
                      value={values.phone}
                      onChange={handlePhone("phone")}
                      required
                      // defaultValue={auth.user.phone}
                    />
                  </div>
                  {/* <div className="form-group">
                      <strong>Address:</strong>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter address"
                        value={values.address}
                        onChange={handleChange("address")}
                        required
                        // defaultValue={auth.user.address}
                      />
                    </div> */}
                  {/* <br /> */}
                  <button
                    type="submit"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#28B8EC",
                      width: "100%",
                      color: "#fff",
                    }}
                  >
                    Sign Up
                  </button>
                </>
                // )
              }
            </form>
          </div>
        </div>
      </div>

      {/* <div className="footer-section">
        <footer>
          <h3
            style={{
              display: "flex",
            }}
          >
            <a className="navbar-brand" href="#">
              <img
                src={footerlogo}
                alt="Logo"
                id="logsedf"
                style={{ width: "52%" }}
              />
            </a>
          </h3>
          <div className="footer-container">
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Let’s do it together
                  </a>
                </li>
                <li>
                  <a href="#">Career</a>
                </li>
                <li>
                  <a href="#">Partner</a>
                </li>
                <li>
                  <a href="#">Couriers</a>
                </li>
                <li>
                  <a href="#">Business</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Link of Interest
                  </a>
                </li>
                <li>
                  <a href="#">About Us</a>
                </li>
                <li>
                  <a href="#">FAQs</a>
                </li>
                <li>
                  <a href="#">Drovi Prime</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
                <li>
                  <a href="#">Security</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Follow us
                  </a>
                </li>
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Twitter</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="app-icons">
                <ul>
                  <li>
                    <a href="#">
                      <img src={googlee} alt="Google Play" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={applee} alt="App Store" />
                    </a>
                  </li>
                  <li>
                    <a href="#">Facebook</a>
                  </li>
                  <li>
                    <a href="#">Twitter</a>
                  </li>
                  <li>
                    <a href="#">Instagram</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>All Rights Reserved. Iconictek Company © 2024</p>
          </div>
        </footer>
      </div> */}
      <br />
      <div className="">
        <div class="curve-wrapper" style={{ marginBottom: "-1px" }}>
          <svg viewBox="0 0 1440 100" class="top-curve">
            <path
              d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
              fill="#000"
            />
          </svg>
        </div>
        {/* <div className="footer-arch-top"></div> */}
        <footer>
          <h3
            style={{
              display: "flex",
            }}
          >
            <a className="navbar-brand" href="#">
              <img
                src={footerlogo}
                alt="Logo"
                id="logsedf"
                style={{ width: "52%" }}
              />
            </a>
          </h3>
          <div className="footer-container">
            <div className="footer-column">
              {/* <h3>Let’s do it together</h3> */}
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Let’s do it together
                  </a>
                </li>
                <li>
                  <a href="#">Career</a>
                </li>
                <li>
                  <a href="#">Partner</a>
                </li>
                <li>
                  <a href="#">Couriers</a>
                </li>
                <li>
                  <a href="#">Business</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Link of Interest
                  </a>
                </li>
                <li>
                  <a href="#">About Us</a>
                </li>
                <li>
                  <a href="#">FAQs</a>
                </li>
                <li>
                  <a href="#">Drovi Prime</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
                <li>
                  <a href="#">Security</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Follow us
                  </a>
                </li>
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Twitter</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="app-icons">
                <ul>
                  <li>
                    <a href="#">
                      <img src={googlee} alt="Google Play" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={applee} alt="App Store" />
                    </a>
                  </li>
                  <li>
                    <a href="#">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Cookies Policy</a>
                  </li>
                  <li>
                    <a href="#">Compilance</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>All Rights Reserved. Iconictek Company © 2024</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default HomeSignUpPage;
